import { useEffect } from 'react';
import { useGetToken } from 'src/services/zora/hooks/useGetToken';
import { useLazyArticleNftReferencesQuery } from '../ArticleCollect/hooks/useArticleNftReferencesQuery';
import ArticleInspireContainer from '../ArticleInspire/ArticleInspireContainer';
import { ArticleInspirePosition } from '../ArticleInspire/constants';
import { ArticleType } from '../Article/types';
import { ArticleHeaderInfoToolbarCollect } from '../ArticleHeaderInfoToolbarCollect/ArticleHeaderInfoToolbarCollect';
import { ArticleHeaderInfoToolbarInteractionsLoader } from './ArticleHeaderInfoToolbarInteractionsLoader';

type TArticleHeaderInfoToolbarInteractionsContainerProps = {
  articleId: string;
  articleSlug: string;
};

export const ArticleHeaderInfoToolbarInteractionsContainer = ({
  articleId,
  articleSlug,
}: TArticleHeaderInfoToolbarInteractionsContainerProps) => {
  const [getArticleNftReferences, { data, loading: isNftReferencesQueryLoading, called }] =
    useLazyArticleNftReferencesQuery({ articleId });
  const nftReference = data?.nftReferences?.[0];
  const hasOnchainNftReference = !!nftReference?.address;
  const { token: tokenData, loading: isTokenLoading, execute: fetchTokens } = useGetToken();

  const loading = isNftReferencesQueryLoading || isTokenLoading;
  const totalMinted = tokenData?.token?.totalMinted;
  const hasTokenData = !!tokenData;

  useEffect(() => {
    if (!articleId) {
      return;
    }

    getArticleNftReferences({ variables: { articleId } });
  }, [articleId]);

  useEffect(() => {
    if (!nftReference?.tokenId || !nftReference?.nftCollectionReference?.address) {
      return;
    }

    fetchTokens({ contractAddress: nftReference.nftCollectionReference.address, tokenId: nftReference.tokenId });
  }, [nftReference?.tokenId, nftReference?.nftCollectionReference?.address]);

  if (!called || loading) {
    return <ArticleHeaderInfoToolbarInteractionsLoader />;
  }

  if (hasOnchainNftReference && hasTokenData) {
    return <ArticleHeaderInfoToolbarCollect articleSlug={articleSlug} totalMinted={Number(totalMinted || 0)} />;
  }

  return (
    <ArticleInspireContainer
      position={ArticleInspirePosition.postHeader}
      articleId={articleId}
      articleType={ArticleType.Article}
    />
  );
};
